import { ComponentType, useEffect, useState } from 'react';

import { ICON_SIZES, loadIcon } from './CustomIconData';

interface IconConfig {
  className?: string;
  size?: number | string;
  color?: string;
}
type Icon = ComponentType<IconConfig> | null;

const CustomIcon = ({
  name,
  size = 'S',
  color = 'var(--black)',
  className
}: IconProps) => {
  const [error, setError] = useState(false);
  const [IconComponent, setIconComponent] = useState<Icon>(null);

  useEffect(() => {
    try {
      setError(false);
      const component = loadIcon(name);
      if (component) setIconComponent(() => component);
      else setError(true);
    } catch (err) {
      setError(true);
      console.error(`Error cargando icono ${name}:`, err);
    }
  }, [name]);

  // Default fallback
  if (error || !IconComponent) {
    return (
      <div
        className={`custom-icon-fallback ${className ?? ''}`}
        style={{
          width: ICON_SIZES[size],
          height: ICON_SIZES[size],
          backgroundColor: '#FFF',
          borderRadius: '50%',
          display: 'inline-block',
          opacity: 0.7
        }}
      />
    );
  }

  return (
    <IconComponent
      className={className}
      size={ICON_SIZES[size]}
      color={color}
    />
  );
};

export default CustomIcon;
